import { tv, type VariantProps } from 'tailwind-variants';
export type MlSmallHeaderVariants = VariantProps<typeof mlHeaderVariants>;

const mlHeaderVariants = tv({
  slots: {
    textContainer: 'flex',
    base: 'relative w-full flex flex-col lg:flex-row',
    cta: 'mt-6 w-fit lg:right-0 lg:top-0 lg:!absolute lg:h-fit',
    cmsSpacing: '',
  },
  variants: {
    alignment: {
      left: { base: 'justify-start text-left' },
      center: {
        base: 'items-center lg:justify-center',
        textContainer: 'items-center text-center',
      },
    },
    order: {
      vertical: { textContainer: 'flex-col' },
      horizontal: { textContainer: 'flex-row items-end' },
    },
    size: {
      small: { textContainer: 'gap-[1.125rem]' },
      large: { textContainer: 'gap-6' },
    },
    topSpacing: {
      xs: {
        cmsSpacing: 'pt-xs',
      },
      sm: {
        cmsSpacing: 'pt-sm',
      },
      md: {
        cmsSpacing: 'pt-md',
      },
      lg: {
        cmsSpacing: 'pt-lg',
      },
      xl: {
        cmsSpacing: 'pt-xl',
      },
    },
    bottomSpacing: {
      xs: {
        cmsSpacing: 'pb-xs',
      },
      sm: {
        cmsSpacing: 'pb-sm',
      },
      md: {
        cmsSpacing: 'pb-md',
      },
      lg: {
        cmsSpacing: 'pb-lg',
      },
      xl: {
        cmsSpacing: 'pb-xl',
      },
    },
  },
  compoundVariants: [],
});

export default mlHeaderVariants;
